interface ActionButtonsProps {
  workflow: {
    path: string;
  };
  workflowId: string;
  runId: string;
}

const TEMPORAL_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8233/namespaces/default/workflows'
    : 'https://cloud.temporal.io/namespaces/core.i0jzq/workflows';

export const ActionButtons = ({ workflow, workflowId, runId }: ActionButtonsProps) => {
  return (
    <div className="flex gap-4">
      {[
        {
          icon: () => (
            <svg
              role="img"
              viewBox="0 0 24 24"
              className="w-4 h-4"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M16.206 7.794C15.64 3.546 14.204 0 12 0 9.796 0 8.361 3.546 7.794 7.794 3.546 8.36 0 9.796 0 12c0 2.204 3.546 3.639 7.794 4.206C8.36 20.453 9.796 24 12 24c2.204 0 3.639-3.546 4.206-7.794C20.454 15.64 24 14.204 24 12c0-2.204-3.547-3.64-7.794-4.206Zm-8.55 7.174c-4.069-.587-6.44-1.932-6.44-2.969 0-1.036 2.372-2.381 6.44-2.969-.09.98-.137 1.98-.137 2.97 0 .99.047 1.99.137 2.968zM12 1.215c1.036 0 2.381 2.372 2.969 6.44a32.718 32.718 0 0 0-5.938 0c.587-4.068 1.932-6.44 2.969-6.44Zm4.344 13.753c-.2.03-1.022.126-1.23.146-.02.209-.117 1.03-.145 1.23-.588 4.068-1.933 6.44-2.97 6.44-1.036 0-2.38-2.372-2.968-6.44-.03-.2-.126-1.022-.147-1.23a31.833 31.833 0 0 1 0-6.23 31.813 31.813 0 0 1 7.46.146c4.068.587 6.442 1.933 6.442 2.969-.001 1.036-2.374 2.382-6.442 2.97z" />
            </svg>
          ),
          label: 'Workflow',
          href: `${TEMPORAL_BASE_URL}/${workflowId}/${runId}/history`,
        },
        {
          icon: () => (
            <svg
              role="img"
              viewBox="0 0 24 24"
              className="w-4 h-4"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
            </svg>
          ),
          label: 'Code',
          href: `https://github.com/growthxai/flow/tree/main/packages/temporal/src/workflows/${workflow.path}`,
        },
      ].map(({ icon: Icon, label, href }) =>
        href ? (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-3 py-1.5 text-secondary hover:text-primary transition-colors"
          >
            <Icon />
            <span className="text-sm font-medium">{label}</span>
          </a>
        ) : (
          <button
            key={label}
            className="flex items-center gap-2 px-3 py-1.5 text-secondary hover:text-primary transition-colors"
          >
            <Icon />
            <span className="text-sm font-medium">{label}</span>
          </button>
        )
      )}
    </div>
  );
};
